module.exports = __webpack_public_path__ + "static/media/handFlexed.f6eb7178.png";